import { equipmentAccessorialSchema } from '../equipment/accessorials.ts'
import { equipmentTypes } from '../equipment/equipment-types.ts'
import {
  vArray,
  vBoolean,
  vBoolStrict,
  vCoerceArray,
  vMinLength,
  vMinValue,
  vNumber,
  vObject,
  vObjectId,
  vOptional,
  vOptionalDef,
  type vOutput,
  vPicklist,
  vPipe,
  vString,
  vWeightUOM,
} from '../validation/index.ts'
import { billToSchema } from './account-bill-to.ts'
import { currency, modes, workflows } from './common.ts'
import { baseCustomsBrokerSchema } from './customs-broker.ts'
import { deliveryOptionSchema } from './delivery-option.ts'
import { emergencyContactSchema } from './emergency-contact.ts'
import { loadHandlingUnitSchema } from './load-handling-unit.ts'
import { apiQuoteRequestLocationSchema } from './load-location.ts'
import { shareSchema } from './share.ts'

const equipmentDtoSchema = vObject({
  loadId: vOptional(vObjectId()),
  quoteId: vOptional(vObjectId()),
  mode: vPicklist(modes),
  type: vPicklist(equipmentTypes.map(e => e.key)),
  alternateTypes: vOptional(vArray(vPicklist(equipmentTypes.map(e => e.key)))),
  accessorials: vOptional(vArray(equipmentAccessorialSchema)),
  description: vOptionalDef(vString(), ''),
  declaredValue: vOptional(vNumber()),
  declaredValueCurrency: vPicklist(currency.map(c => c.key)),
  weight: vPipe(vNumber(), vMinValue(1)),
  weightUOM: vWeightUOM,
  isHazardous: vBoolStrict(),
  items: vOptional(vArray(loadHandlingUnitSchema)),
  billTo: vOptional(billToSchema),
  customsBroker: vOptional(vCoerceArray(baseCustomsBrokerSchema)),
  emergencyContact: vOptional(emergencyContactSchema),
  deliveryOption: vOptional(deliveryOptionSchema),
})

export const apiQuoteRequestSchema = vObject({
  locations: vPipe(vArray(apiQuoteRequestLocationSchema), vMinLength(2)),
  equipment: vPipe(vArray(equipmentDtoSchema), vMinLength(1)),
  workflow: vPicklist(workflows),
  orderNumber: vOptional(vString()),
  isLiveLoad: vBoolStrict(),
  schedulePickup: vOptional(vBoolean()),
  billTo: vOptional(billToSchema),
  isFreightCollect: vOptional(vBoolean()),
  rateLocationType: vOptional(vPicklist(['origin', 'destination'])),
  glCode: vOptional(vString()),
  brandId: vOptional(vObjectId()),
  tags: vOptional(vArray(vString())),
  shares: vOptional(vArray(shareSchema)),
  templateId: vOptional(vObjectId()),
})

export type ApiQuoteRequestEquipmentDTO = vOutput<typeof equipmentDtoSchema>
export type ApiQuoteRequestLocationDTO = vOutput<
  typeof apiQuoteRequestLocationSchema
>
export type ApiQuoteRequestDTO = vOutput<typeof apiQuoteRequestSchema>
